// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, collection, addDoc, getDocs, query, orderBy, Timestamp } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAQcVjwhy1ud39QNytZHeMBusZpIlJkBdY",
    authDomain: "albo-labs.firebaseapp.com",
    projectId: "albo-labs",
    storageBucket: "albo-labs.firebasestorage.app",
    messagingSenderId: "222766532392",
    appId: "1:222766532392:web:59177e7cf322615885b21d",
    measurementId: "G-KD4VCT716L"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

// Function to save contact form submission
export const saveContactSubmission = async (formData) => {
    try {
        const docRef = await addDoc(collection(db, "contact_submissions"), {
            ...formData,
            timestamp: Timestamp.now(),
            status: 'new'
        });
        console.log("Document written with ID: ", docRef.id);
        return { success: true, id: docRef.id };
    } catch (error) {
        console.error("Error adding document: ", error);
        return { success: false, error: error.message };
    }
};

// Function to get all contact submissions
export const getContactSubmissions = async () => {
    try {
        const q = query(
            collection(db, "contact_submissions"),
            orderBy("timestamp", "desc")
        );
        const querySnapshot = await getDocs(q);
        const submissions = [];
        querySnapshot.forEach((doc) => {
            submissions.push({
                id: doc.id,
                ...doc.data()
            });
        });
        return { success: true, data: submissions };
    } catch (error) {
        console.error("Error getting documents: ", error);
        return { success: false, error: error.message };
    }
};

export { db, analytics };
